import mig2 from './2';
import mig3 from './3';

export const currentVersion = 3;

const migrations = {
    2: mig2,
    3: mig3,
};

export default migrations;
